import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sprout, XCircle, Zap } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white" data-id="element-226">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="max-w-4xl mx-auto" data-id="element-228">
          {/* The 3 Errors - Mechanism */}
          <div className="text-center mb-16" data-id="element-229">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-230">
              El 90% de los fracasos en esquejes se debe a 3 errores específicos
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-231">
              Cuando los corriges, el éxito no es suerte. Es predecible.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-232">
            {[{
            number: 1,
            title: 'Momento equivocado',
            desc: 'Cortaron en el momento equivocado del ciclo de la planta.'
          }, {
            number: 2,
            title: 'Tipo de esqueje incorrecto',
            desc: 'Usaron el tipo de esqueje incorrecto para esa especie.'
          }, {
            number: 3,
            title: 'Sin control del medio',
            desc: 'No controlaron humedad, temperatura ni medio de enraizamiento.'
          }].map((error, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-red-50 p-6 rounded-2xl border border-red-100 text-center" data-id="element-233">
                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4" data-id="element-234">
                  <XCircle className="w-6 h-6 text-red-500" data-id="element-235" />
                </div>
                <span className="text-xs font-bold text-red-500 uppercase tracking-wide" data-id="element-236">
                  Error {error.number}
                </span>
                <h3 className="text-lg font-bold text-gray-900 mt-2 mb-2" data-id="element-237">
                  {error.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-238">{error.desc}</p>
              </motion.div>)}
          </div>

          {/* The Method */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#4a7c2c] rounded-2xl p-8 md:p-10 text-white text-center mb-16" data-id="element-239">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-white/20 rounded-full mb-6" data-id="element-240">
              <Zap className="w-7 h-7" data-id="element-241" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-242">
              El Método Esqueje Maestro
            </h3>
            <p className="text-lg text-white/90 max-w-2xl mx-auto" data-id="element-243">
              Un sistema de 5 pasos que lleva a cualquier persona desde cero
              hasta la multiplicación exitosa y consistente de plantas — con
              posibilidad de escalar a nivel comercial.
            </p>
          </motion.div>

          {/* Product Presentation */}
          <div className="text-center mb-12" data-id="element-244">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#4a7c2c]/10 rounded-full mb-6" data-id="element-245">
              <Sprout className="w-8 h-8 text-[#4a7c2c]" data-id="element-246" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-247">
              Presentamos: La Guía de Esquejes
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-248">
              El sistema completo para multiplicar cualquier planta — desde casa
              hasta nivel de vivero.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-249">
            {['Multiplicar tus plantas favoritas con alta tasa de éxito', 'Entender el "por qué" detrás de cada paso (no solo el "cómo")', 'Aplicar las técnicas correctas según el tipo de planta', 'Escalar tu producción si quieres vender'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3 bg-[#fafaf9] p-5 rounded-xl border border-gray-100" data-id="element-250">
                <div className="mt-0.5 w-6 h-6 rounded-full bg-[#4a7c2c]/10 flex items-center justify-center flex-shrink-0" data-id="element-251">
                  <Check className="w-4 h-4 text-[#4a7c2c]" data-id="element-252" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-253">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}